














import {Component, Vue, Prop} from 'vue-property-decorator';
import MultiTable from '@/components/Elements/MultiTable.vue';
import PDFListViewer from '@/components/Elements/PDFListViewer.vue'

@Component({
  components: {
    MultiTable,
    PDFListViewer
  }
})
export default class NewsItem extends Vue {
  @Prop({default: ''}) selectedNewsItem!: '';
  PDFViewerActive = false;
  selectedPDFs = []
  selected = {}

  back() {
    this.$emit('back', false);
  }
  showPDF($event) {
    this.selectedPDFs = $event;
    this.PDFViewerActive = true;
    this.selected = {
      title: $event[0].title,
      pdf: $event[0].pdf
    }
  }
}
